import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import { selectAllAssets } from 'providers/AssetLoader/store/selectors'

/**
 * Company Type filter template that gets options from assets
 * @param {object} options - Filter options from PrimeReact column
 */
const CompanyTypeFilterTemplate = ({ options }) => {
    const assets = useSelector(selectAllAssets)
    const companyTypes = assets?.companyTypes || []
    
    const dropdownOptions = [
        { label: 'Empty', value: '__EMPTY__' },
        ...companyTypes.map(ct => ({
            label: ct.description,
            value: ct.id
        }))
    ]

    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Company Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default CompanyTypeFilterTemplate
